import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getBitacorasCorrectasIncorectas, getRotacionDeOperadores } from '../integracionDashboard';
import { InputText } from 'primereact/inputtext';

const ModalRotacionDeOperadores = ({ title, visible, onHide, params, id }) => {
  const [data, setData] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [loading, setLoading] = useState(true);
  const onGlobalFilterChange = (e) => {
    setGlobalFilterValue(e.target.value);
  };
  const renderHeader = () => {
    return (
      <div className="table-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span className="p-input-icon-left">
          <i className="pi pi-search" style={{ paddingLeft: '20px' }} />
          <InputText
            type="search"
            onChange={onGlobalFilterChange}
            placeholder="Buscar..."
            value={globalFilterValue}
            style={{ paddingLeft: '40px' }}
          />
        </span>
        {/* <Button label='Descargar exel' onClick={()=>{BotonDescargarExel()}}></Button> */}
      </div>
    );
  };
  useEffect(() => {
    if (params && visible) {
      getRotacionDeOperadores(params, setData,setLoading)
    }
    if(!visible)
    {
      setLoading(true)
      setData([])
    }
  }, [visible])


  return (
    <Dialog header={title} visible={visible}  headerStyle={{background:"white",color:"black"}} headerClassName='colorex' style={{ width: '40vw' }} modal onHide={onHide}>
      <DataTable value={data} paginator rows={5} globalFilter={globalFilterValue} header={renderHeader()} loading={loading}>
        <Column field="ID_UNIDAD" header="ID_UNIDAD" />
        <Column field="OPERADORES_DISTINTOS" header="OPERADORES_DISTINTOS" />
      </DataTable>
    </Dialog>
  );
};

export default ModalRotacionDeOperadores;
